var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import Dropzone from 'react-dropzone';
import styles from './FileInput.module.css';
var DEFAULT_MAX_FILE_SIZE_BYTES = 20 * Math.pow(10, 6); // 20 megabytes
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function FileInput(props) {
    var maxFileSizeBytes = props.maxFileSizeMb
        ? props.maxFileSizeMb * Math.pow(10, 6)
        : DEFAULT_MAX_FILE_SIZE_BYTES;
    var maxFileSizeMb = maxFileSizeBytes / Math.pow(10, 6);
    var deleteFile = function (fileToDelete) {
        var files = props.files.filter(function (file) { return file.name !== fileToDelete.name; });
        props.handleAcceptedFiles(files);
    };
    var createFileElement = function (file) {
        var MAX_NAME_SYMBOLS = 25;
        var name = file.name.length < MAX_NAME_SYMBOLS
            ? file.name
            : file.name.slice(0, MAX_NAME_SYMBOLS) + '...';
        return (React.createElement("div", { className: styles.fileContainer, key: file.name },
            React.createElement("button", { type: 'button', className: styles.deleteButton, onClick: function () { return deleteFile(file); } }),
            React.createElement("div", { className: styles.fileName }, name)));
    };
    var acceptFiles = function (files) {
        var allFiles = props.files.concat(files);
        var totalSize = allFiles.reduce(function (acc, file) { return acc + file.size; }, 0);
        if (totalSize > maxFileSizeBytes) {
            props.showAlert("\u0421\u0443\u043C\u043C\u0430\u0440\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0444\u0430\u0439\u043B\u043E\u0432 \u0431\u043E\u043B\u044C\u0448\u0435 ".concat(maxFileSizeMb, " \u041C\u0411"));
        }
        else {
            props.handleAcceptedFiles(allFiles);
        }
    };
    var handleRejected = function () {
        props.showAlert("\u0424\u0430\u0439\u043B \u0431\u043E\u043B\u044C\u0448\u0435 ".concat(maxFileSizeMb, " \u041C\u0411"));
    };
    return (React.createElement(Dropzone, { accept: props.accept, multiple: true, maxSize: maxFileSizeBytes, onDrop: acceptFiles, onDropRejected: handleRejected }, function (_a) {
        var _b;
        var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps;
        return (React.createElement("section", { className: styles.container, style: props.style },
            React.createElement("div", __assign({}, getRootProps(), { className: styles.input }),
                React.createElement("input", __assign({}, getInputProps())), (_b = props.title) !== null && _b !== void 0 ? _b : "\u041F\u0440\u0438\u043A\u0440\u0435\u043F\u0438\u0442\u044C \u0444\u0430\u0439\u043B (\u0434\u043E ".concat(maxFileSizeMb, " \u041C\u0411)")),
            props.files.map(createFileElement),
            !props.isValid && (React.createElement("span", { style: { color: 'var(--red)', fontSize: '16px' } }, props.validationMessage))));
    }));
}
